// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"4dc86152","453":"52a6bbc7","548":"7cc6ddbf","644":"8b32b7c8","667":"4840cffb"}[chunkId] + ".chunk.js";
};